import React, { useEffect } from "react";
import { connect } from "react-redux";
import InventoryTypeTable from "../InventoryTypeTable";
import { getResourceTypes } from "../store/actions";

const InventoryTypeList = ({
  getResourceTypes,
  restypes
}) => {

  useEffect(() => {
    getResourceTypes();
  }, []);

  return (
    <div>
      <InventoryTypeTable getResourceTypes={getResourceTypes} restypes={restypes}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  restypes: state.nomenclature.restypes
});

const mapDispatchToProps = dispatch => ({
  getResourceTypes: () => dispatch(getResourceTypes())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryTypeList);
